import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ProductConfiguration } from '@df/module-product-configuration/model/product-configuration';
import { Customer } from '@df/session/api/customer';
import { CustomerModel } from '@df/session/api/customer.model';
import { PriceService } from '@df/ui/price/price.service';
import { UiComponent } from '@df/ui/ui.component';
import sum from 'lodash-es/sum';
import { Product } from '../../catalog/product/product.decorator';
import { TradeService } from '../../checkout/module/trade/trade.service';
import { BasketItem } from '@df/session/api/basket/basket-item';

@Component({
    selector: 'become-pro-banner',
    templateUrl: './become-pro-banner.html',
    styleUrls: ['./become-pro-banner.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BecomeProBannerComponent extends UiComponent {
    private basket = inject(Customer)?.basket;
    private tradeService = inject(TradeService);
    private priceService = inject(PriceService);
    private customeModel = inject(CustomerModel);
    private productConfiguration = inject(ProductConfiguration, { optional: true });

    protected price: number = 0;

    @Input()
    accouiredDiscountMode = false;

    @Input()
    source?: BasketItem[];

    override ngOnInit(): void {
        this.subscriptions.add(this.priceService.catalogPricesInclTax$.subscribe(() => this.update()));
        this.customeModel.obs.data.subscribe(() => this.update());
        if (this.productConfiguration) {
            this.subscriptions.add(this.productConfiguration.product$.subscribe(() => this.update()));
            this.subscriptions.add(this.productConfiguration.qty$.subscribe(() => this.update()));
        } else {
            this.subscriptions.add(this.basket.basketUpdateSubject.subscribe(() => this.update()));
        }
        super.ngOnInit();
    }

    private update() {
        const price = this.canUse() ? this.getPrice() : 0;
        if (price !== this.price) {
            this.price = price;
            this.detectChanges();
        }
    }

    /**
     * If banner can be used
     * if trade customer then only when accouiredDiscountMode is presented
     * if non-trade customer then only when showing potential profit
     */
    private canUse(): boolean {
        return this.tradeService.isTradeCustomer() ? this.accouiredDiscountMode : !this.accouiredDiscountMode;
    }

    private getPrice(): number {
        // direct source mode
        if (this.source) {
            return this.getBasketItemsPrice(this.source);
        }

        // PDP mode
        if (this.productConfiguration) {
            return (
                (this.productConfiguration.product$.value as Product).calcTradeDiscount(this.productConfiguration.toBasketRequest()) *
                this.productConfiguration.qty$.value
            );
        }

        // basket mode
        return this.getBasketItemsPrice(this.basket.items);
    }

    private getBasketItemsPrice(items: BasketItem[]): number {
        return items?.length ? sum(items.map(i => (i.product as Product).calcTradeDiscount(i.data.request) * i.qty)) : 0;
    }
}
